import { combineReducers, configureStore } from '@reduxjs/toolkit';
import searchFilterSlice from 'features/AISearch/slices/searchFilterSlice';
import searchSessionSlice from 'features/AISearch/slices/searchSessionSlice';
import searchFilterSliceV2 from 'features/AISearchV2/slices/searchFilterSlice';
import searchSliceV2 from 'features/AISearchV2/slices/searchSlice';
import tagsFilterSlice from 'features/Anticipation/slice/tagsFilterSlice';
import generalAssistantSlice from 'features/GeneralAssistant/slice/generalAssistantSlice';
import inventionAssistantSlice from 'features/InventionAssistant/slice/inventionAssistantSlice';
import launchpadSlice from 'features/Launchpad/slice/inventionDisclosureSlice';
import litigationAssistantSlice from 'features/LitigationAssistant/slice/litigationAssistantSlice';
import officeActionSlice from 'features/OfficeActionsV2/slice/officeActionSlice';
import aiConversationSectionsSlice from 'features/PatentDrafting/slice/aiConversationSectionsSlice';
import patentDraftSectionsSlice from 'features/PatentDrafting/slice/patentDraftSectionsSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import featureTreeSlice from '../features/FeatureTree/slice/featureTreeSlice';
import FTOSlice from '../features/FTO/slices/FTOSlice';
import infringementDetectionSlice from '../features/InfringementDetection/slices/infringementDetectionSlice';
import appSlice from './slices/appSlice';
import authSlice from './slices/authSlice';
import claimChartSlice from './slices/claimChartSlice';
import coachMarkSlice from './slices/coachMarkSlice';
import developerToolsSlice from './slices/developerToolsSlice';
import documentViewerScrollSlice from './slices/documentViewerSlice';
import drawerPatentSlice from './slices/drawerPatentSlice';
import figureSlice from './slices/figureSlice';
import inventionDisclosureSlice from './slices/inventionDisclosureSlice';
import panelSlice from './slices/panelSlice';
import referenceSignsSectionsSlice from './slices/referenceSignsSlice';
import tabScrollSlice from './slices/tabScrollSlice';
import workspaceSlice from './slices/workspaceSlice';

const rootReducer = combineReducers({
  authSlice,
  appSlice,
  infringementDetectionSlice,
  FTOSlice,
  claimChartSlice,
  inventionDisclosureSlice,
  workspaceSlice,
  featureTreeSlice,
  drawerPatentSlice,
  searchSessionSlice,
  searchFilterSlice,
  aiConversationSectionsSlice,
  patentDraftSectionsSlice,
  launchpadSlice,
  figureSlice,
  referenceSignsSectionsSlice,
  searchSliceV2,
  searchFilterSliceV2,
  tagsFilterSlice,
  documentViewerScrollSlice,
  generalAssistantSlice,
  inventionAssistantSlice,
  litigationAssistantSlice,
  officeActionSlice,
  panelSlice,
  tabScrollSlice,
  coachMarkSlice,
  developerToolsSlice,
});

export type RootState = ReturnType<typeof store.getState>;

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

type RootReducerType = typeof rootReducer;
type AppDispatchType = typeof store.dispatch;
type AppRootStateType = ReturnType<RootReducerType>;
export const useAppDispatch: () => AppDispatchType = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppRootStateType> = useSelector;
